import React, { useEffect, useState } from "react";
import { Button, Typography, Space, Avatar, Form, Col } from "antd";
import { UserOutlined, DownOutlined, UpOutlined } from "@ant-design/icons";
import {
  usePropertiesDispatch,
  usePropertiesState,
} from "../../contexts/properties";
import { actions } from "../../contexts/properties/actions";
import WriteReviewModal from "../WriteReviewModal";
import PreviewReviews from "../PreviewReviews";

const ReviewTab = (props: { propertyId: number }) => {
  const { propertyId } = props

  const [firstName, setFirstName] = useState<string>('')
  const [lastName, setLastName] = useState<string>('')
  const [email, setEmail] = useState<string>('')
  const [title, setTitle] = useState<string>('')
  const [comments, setComments] = useState<string>('')

  const [open, setOpen] = useState<boolean>(false);
  const [reviewsList, setReviewList] = useState<any>([])
  const [form] = Form.useForm();

  const dispatch = usePropertiesDispatch();
  const { isReviewSubmitting, reviews } = usePropertiesState();

  useEffect(() => {
    const getReviewsList = async () => {
      await actions.getReviews(dispatch, propertyId);
    }
    getReviewsList()
    reviews && setReviewList(reviews)
  }, [dispatch, propertyId]);
  
  console.log(reviews)

  const handleSubmit = async () => {
    try {
      // const data = await form.validateFields();
      const body = {
        firstName,
        lastName,
        email,
        title,
        comments,
        propertyId,
      }
      const success = await actions.postReview(dispatch, { fields: body });

      if (success) {
        setOpen(false);
        form.resetFields();
        window.location.reload();
      }
    } catch (info) {
      console.error(info);
    }
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const handleRead = (index: number) => {
    let list = [...reviews]
    list[index].readmore = !list[index].readmore
    setReviewList(list)
  }

  console.log(reviewsList)

  return (
    <Col>
      <Button block onClick={() => setOpen(!open)}>
        Write a Review
      </Button>
      <WriteReviewModal
        open={open}
        form={form}
        isReviewSubmitting={isReviewSubmitting}
        handleCancel={handleCancel}
        handleSubmit={handleSubmit}
        setFirstName={setFirstName}
        setLastName={setLastName}
        setEmail={setEmail}
        setTitle={setTitle}
        setComments={setComments}
      />
      {reviews &&
        <div style={{ margin: "10px" }}>
          {reviews.map((review: any, index: number) => {
            console.log(review)
            return <PreviewReviews
              review={review.fields}
              index={index}
              handleRead={() => { handleRead(index) }} />
          })}
        </div>
      }
    </Col>
  );
};

export default ReviewTab;
